// src/utils/ticket.formState.ts
import { SupportTicketForm, MenuId, CategoryId, FunctionId } from '../../types/ticket';


const getUserName = ()=>{
  const userEmail = (localStorage.getItem("userId") || sessionStorage.getItem("userId") || "").trim();
  return userEmail
}
export const getInitialFormState = (): SupportTicketForm => ({
  menu: '',
  category: '',
  func: '',
  assignedTo: '',
  plantid:"",
  selectedRow:[{
  materialNumber: '',
  ioExtractionDate: '',}],
  description:'',
  ticketCaseId:"APPLICATION_LEVEL_INCIDENT",
  initiator: getUserName(),
  urgent: false,
});

/** @deprecated use getInitialFormState() instead */
export const initialFormState: SupportTicketForm = getInitialFormState();

export const resetOnMenuChange = (prev: SupportTicketForm, menu: string): SupportTicketForm => ({
  ...prev, menu: menu as MenuId, category: '', func: '', assignedTo: '',
});

export const resetOnCategoryChange = (prev: SupportTicketForm, category: string): SupportTicketForm => ({
  ...prev, category: category as CategoryId, func: '', assignedTo: '',
});

export const resetOnFunctionChange = (prev: SupportTicketForm, func: string): SupportTicketForm => ({
  ...prev, func: func as FunctionId, assignedTo: '',
});